import React from "react";

export const Features = (props) => {
  return (
    <div id={props.data ? props.data.main.toLowerCase().replace(/ /g, "_") : "loading..."} className="text-center features">
      <div className="container">
        <div className="col-md-12 section-title">
          <h2> {props.data ? props.data.title : "Loading"}</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.paragraphs.map((d, i) => (
              <div key={`${i}`} className="col-md-12">
                {" "}
                <p>{d}</p>
              </div>
            ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
